"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _MainStore = require("../stores/MainStore");

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Utility = require("../utils/Utility");

var Utils = _interopRequireWildcard(_Utility);

var _ItemList = require("./ItemList");

var _ItemList2 = _interopRequireDefault(_ItemList);

var _itemPreview = require("./item-preview");

var _itemPreview2 = _interopRequireDefault(_itemPreview);

var _reactScroll = require("react-scroll");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_React$Component) {
	_inherits(List, _React$Component);

	function List(props) {
		_classCallCheck(this, List);

		var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

		_this.state = {
			groupHierarchy: [],
			isResturantOpen: true,
			renderMenuItems: false
		};
		return _this;
	}

	_createClass(List, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			this.setState({
				groupHierarchy: this.props.groupHierarchy,
				isResturantOpen: this.props.isResturantOpen,
				renderMenuItems: true
			});
		}
	}, {
		key: "UNSAFE_componentWillReceiveProps",
		value: function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
			if (this.props.groupHierarchy !== nextProps.groupHierarchy) {
				this.setState({
					groupHierarchy: nextProps.groupHierarchy,
					isResturantOpen: nextProps.isResturantOpen
				});
			}
		}
	}, {
		key: "renderMenuItems",
		value: function renderMenuItems() {
			var _this2 = this;

			var groupHierarchy = this.state.groupHierarchy || [];

			return groupHierarchy.map(function (groupedObj) {

				var groupName = groupedObj.groupDetail.groupName;
				var pGroupId = groupedObj.groupDetail.objectId;
				var groupId = "" + groupName.trim().replace(/[^A-Z0-9]+/ig, "_");

				// console.log(groupName + ": " +groupedObj.openHours);

				// get date time based on the location
				var dateTime = _MainStore2.default.getCurrentDateTime();

				// check hideAfterHours is set or not
				// check current time exist in the group open hours
				var isGroupVisible = Utils.isGroupShownAfterHours(groupedObj.groupDetail, dateTime);

				if (isGroupVisible != false) {
					if (groupedObj.groupType === 'MENU') {
						return _react2.default.createElement(
							_reactScroll.Element,
							{
								name: groupId.toString(),
								className: groupId,
								key: "display" + groupId
							},
							_react2.default.createElement(
								"h4",
								{ className: "font-weight-bold mt-3 mb-1", key: "group_" + groupId },
								groupName
							),
							groupedObj.subGroups.map(function (subGroupObj) {
								// get date time based on the location
								var dateTime = _MainStore2.default.getCurrentDateTime();
								// check hideAfterHours is set or not
								// check current time exist in the group open hours
								var isSubGroupVisible = Utils.isGroupShownAfterHours(subGroupObj.groupDetail, dateTime);
								// console.log("isSubGroupVisible: " + isSubGroupVisible)

								if (isSubGroupVisible != false) {
									return _react2.default.createElement(_ItemList2.default, {
										itemDetails: subGroupObj.sortedItemDetails,
										groupDesc: subGroupObj.groupDetail.groupDesc,
										openHours: subGroupObj.groupDetail.openHours || groupedObj.groupDetail.openHours,
										parentCategory: groupName,
										category: subGroupObj.groupDetail.groupName,
										key: pGroupId + "-m" + subGroupObj.groupDetail.objectId,
										isResturantOpen: _this2.state.isResturantOpen
										// loadScheduleScreen={this.props.loadScheduleScreen}
										// showScheduleModal = {this.props.showScheduleModal}
										// handleScheduleModal={callbackParent}

									});
								}
							})
						);
					} else {

						return _react2.default.createElement(_ItemList2.default, {
							itemDetails: groupedObj.sortedItemDetails,
							groupDesc: groupedObj.groupDetail.groupDesc,
							openHours: groupedObj.groupDetail.openHours,
							category: groupName,
							key: "m" + pGroupId,
							isResturantOpen: _this2.state.isResturantOpen
							// loadScheduleScreen={this.props.loadScheduleScreen}
							// showScheduleModal = {this.props.showScheduleModal}
							// handleScheduleModal={callbackParent}
						});
					}
				}
			});
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					"section",
					{ className: "section products-listing ", key: "list-component" },
					_react2.default.createElement(
						"div",
						{ className: "container" },
						this.renderMenuItems()
					)
				)
			);
		}
	}]);

	return List;
}(_react2.default.Component);

exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./src/components/List.jsx
// module id = 445
// module chunks = 0